import type { IconSvgObject } from './types';

const ArrowUpLeft02Icon: IconSvgObject = [
  ["path", { d: "M10 10L18 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.00026 13L6 6L13.0003 7L7.00026 13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpLeft02Icon;
